var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('span',{staticClass:"spinner-border spinner-border-sm ml-2",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }